import { component } from 'picoapp';
import Marquee3k from 'marquee3000';

export default component((node, ctx) => {
  // Marquee3k.init({
  //   selector: 'instagram-scroller',
  // });
});
